// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xN2ZNfU5ppkF2HfaW63L{align-items:center;margin-bottom:19px;padding-left:7px}.xN2ZNfU5ppkF2HfaW63L input{height:20px;font-size:16px}.xN2ZNfU5ppkF2HfaW63L input::placeholder{color:var(--content-neutral-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `xN2ZNfU5ppkF2HfaW63L`
};
export default ___CSS_LOADER_EXPORT___;
